import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isSideBarOpen: true,
};

const sidebarVarSlice = createSlice({
  name: "sidebarVariables",
  initialState,
  reducers: {
    setIsSideBarOpen: (state, action) => {
      state.isSideBarOpen = action.payload;
    },
  },
});

export const { setIsSideBarOpen } = sidebarVarSlice.actions;

export default sidebarVarSlice.reducer;
